<template>
  <div class="frmware-task-detail-dialog-bd">
    <el-drawer size="1400px" :title="model.title" :visible="visible" :before-close="closeDialog" class="frmware-task-drawer" :append-to-body="true">
      <div class="info-content">
        <div class="info-content-box">
          <div class="info-box">
            <div class="title">{{ $t('dms_firmwareTask_detail_dialog.ji_ben_xin_xi') }}</div>
            <ul class="information">
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.ren_wu_ming_cheng') }}
                <span class="right">{{ info.taskName }}</span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.ren_wu_lei_xing') }}
                <span class="right">
                  {{ iot_cmd_task_service_type[info.serviceType] }}
                </span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.ren_wu_lai_yuan') }}
                <span class="right">{{ getDicValue('iot_cmd_task_source', info.taskSource) }}</span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.chan_pin_xing_hao') }}
                <span class="right">{{ info.productCode }}</span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.xie_yi') }}
                <span class="right">{{ info.protocolName + ' / ' + info.tcpVersion }}</span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.Topicbian_ma') }}
                <span class="right">{{ info.topicCode }}</span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.rwzxsj') }}
                <span class="right">{{ momentAmPm($momentLocal(info.taskStartTime) || '-') }}</span>
              </li>
              <li class="line">
                {{ $t('dms_firmwareTask_detail_dialog.ren_wu_zhuang_tai') }}
                <span class="right">{{ getDicValue('iot_cmd_task_status', info.taskStatus) }}</span>
              </li>
              <li class="line-break">
                <p>{{ $t('dms_firmwareTask_detail_dialog.ren_wu_miao_shu') }}</p>
                <span>{{ info.taskDesc }}</span>
              </li>
            </ul>
            <p class="device-num">
              {{ $t('dms_firmwareTask_detail_dialog.she_bei_zong_shu_tai') }}
              <span>{{ info.taskDeviceNum }}</span>
            </p>
            <div class="device">
              <li class="line">
                <span class="l" :title="$t('dms_firmwareTask_detail_dialog.wei_zhi_xing')">
                  {{ $t('dms_firmwareTask_detail_dialog.wei_zhi_xing') }}
                </span>
                <span class="progress">
                  <el-progress
                    v-if="(info.taskWaitNum / info.taskDeviceNum) * 100"
                    :percentage="(info.taskWaitNum / info.taskDeviceNum).toFixed(2) * 100"
                    :format="progressFormat"
                    color="#F9C851"
                  ></el-progress>
                </span>
                <span class="right">{{ info.taskWaitNum }}</span>
              </li>
              <li class="line">
                <span class="l" :title="$t('dms_firmwareTask_detail_dialog.zhi_xing_zhong')">
                  {{ $t('dms_firmwareTask_detail_dialog.zhi_xing_zhong') }}
                </span>
                <div class="progress">
                  <el-progress
                    v-if="(info.taskExecutingNum / info.taskDeviceNum) * 100"
                    :percentage="(info.taskExecutingNum / info.taskDeviceNum).toFixed(2) * 100"
                    color="#37B8E0"
                    :format="progressFormat"
                  ></el-progress>
                </div>
                <span class="right">{{ info.taskExecutingNum }}</span>
              </li>
              <li class="line">
                <span class="l" :title="$t('dms_firmwareTask_detail_dialog.zhi_xing_cheng_gong')">
                  {{ $t('dms_firmwareTask_detail_dialog.zhi_xing_cheng_gong') }}
                </span>
                <span class="progress">
                  <el-progress
                    v-if="(info.taskSuccessNum / info.taskDeviceNum) * 100"
                    :percentage="(info.taskSuccessNum / info.taskDeviceNum).toFixed(2) * 100"
                    :format="progressFormat"
                    color="#0D9AE0"
                  ></el-progress>
                </span>
                <span class="right">{{ info.taskSuccessNum }}</span>
              </li>
              <li class="line">
                <span class="l" :title="$t('dms_firmwareTask_detail_dialog.zhi_xing_shi_bai')">
                  {{ $t('dms_firmwareTask_detail_dialog.zhi_xing_shi_bai') }}
                </span>
                <span class="progress">
                  <el-progress
                    v-if="(info.taskFailedNum / info.taskDeviceNum) * 100"
                    :percentage="(info.taskFailedNum / info.taskDeviceNum).toFixed(2) * 100"
                    :format="progressFormat"
                    color="#FF5C5B"
                  ></el-progress>
                </span>
                <span class="right">{{ info.taskFailedNum }}</span>
              </li>
              <li class="line">
                <span class="l" :title="$t('dms_firmwareTask_detail_dialog.ren_wu_qu_xiao')">
                  {{ $t('dms_firmwareTask_detail_dialog.ren_wu_qu_xiao') }}
                </span>
                <span class="progress">
                  <el-progress
                    v-if="(info.taskCancelNum / info.taskDeviceNum) * 100"
                    :percentage="(info.taskCancelNum / info.taskDeviceNum).toFixed(2) * 100"
                    :format="progressFormat"
                    color="#98A6AD"
                  ></el-progress>
                </span>
                <span class="right">{{ info.taskCancelNum }}</span>
              </li>
            </div>
          </div>
          <div class="table-box">
            <!--
              command_mode
              1-服务.提示确认，
              2-服务.状态更改，
              3-服务.弹框录入，
              4-配置.表单录入，
              5-配置.数据存档，
              6-配置.历史选择
            -->
            <!-- 指令参数 -->
            <!-- 指令参数  状态是commandTaskParamList  详情是tslList 账单共用 -->
            <template v-if="`${commandMode}` !== '5'">
              <h2 class="table-title">
                {{ $t('dms_firmwareTask_detail_dialog.zhi_ling_xin_xi') }}
              </h2>
              <el-table ref="tb1" border :size="allTableSize" v-if="contentList" :data="contentList" v-loading="isLoading" style="flex: initial;height: 100px;flex: 0 0 100px;">
                <template v-for="(item, index) in paramTableColumn">

                  <el-table-column v-if="item.dicGroup" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ getDicValue(item.dicGroup, scope.row[item.columnCode]) }}
                      <!-- {{item.columnCode}} -->
                    </template>
                  </el-table-column>
                  <!-- 账单日期 -->
                  <!-- dataCode: "billDate" -->
                  <el-table-column v-if="item.columnCode === 'billEndDate'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <!-- {{ getDicValue(item.dicGroup,scope.row[item.columnCode]) }} -->
                      {{ formatDateTime(scope.row[item.columnCode]) }}
                    </template>
                  </el-table-column>
                  <el-table-column v-if="`${item.widgetType}` === '5'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ formatHhmmStr(scope.row[item.columnCode]) }}
                    </template>
                  </el-table-column>
                  <el-table-column v-if="`${item.widgetType}` === '8'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ formatDateTime(scope.row[item.columnCode]) }}
                    </template>
                  </el-table-column>
                  <!-- 固件地址要做权限显示  -->
                  <el-table-column v-if="item.columnCode === 'url'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ funcView.firmware_task_download? scope.row[item.columnCode]:'-' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="!item.dicGroup && item.columnCode !== 'billEndDate' && `${item.widgetType}` !== '5'&&`${item.widgetType}` !== '8'&& item.columnCode !== 'url'"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    show-overflow-tooltip
                  ></el-table-column>
                </template>
              </el-table>
            </template>
            <template v-if="`${commandMode}` === '5'">
              <h2 class="table-title">
                {{ $t('dms_firmwareTask_detail_dialog.zhang_dan_xin_xi') }}
              </h2>
              <!--存档类型 5 账单  -->
              <el-table v-if="recoverHisTable" :data="recoverHisTable" border max-height="100" style="width: 100%;flex: initial;height: 100px;flex: 0 0 100px;">
                <!-- <el-table-column v-for="(item, index) in tableSingleColumn" :key="index" :prop="item.columnCode" :label="item.columnName"></el-table-column> -->
                <!-- 配置列 -->
                <template v-for="(item, index) in tableSingleColumn">
                  <!-- 字典 -->
                  <el-table-column
                    v-if="item.selected && item.dicGroup && !item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                    :column-key="item.columnCode"
                    :filter-multiple="true"
                    :filters="item.filters"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row, column }">
                      {{ getDicValue(item.dicGroup, row[column.property]) }}
                    </template>
                  </el-table-column>
                  <!-- 单位 -->
                  <el-table-column
                    v-if="item.selected && item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                  >
                    <template slot-scope="{ row, column }">
                      <span>{{ row[column.property] }}</span>
                      <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.showUnit) }}</span>
                    </template>
                  </el-table-column>
                  <!--
                        datetime 5 时间控件
                    -->
                  <el-table-column
                    v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                  >
                    <template slot-scope="{ row, column }">
                      {{ formatDateTime(row[column.property]) }}
                    </template>
                  </el-table-column>
                  <!-- 非字典  时间控件 -->
                  <el-table-column
                    v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                    :column-key="item.columnCode"
                    :filter-multiple="true"
                    :filters="item.filters"
                    show-overflow-tooltip
                  ></el-table-column>
                </template>
                <!-- 占位列 -->
                <el-table-column v-if="!tableSingleColumn.length"></el-table-column>
              </el-table>
              <!-- <div class="table-bd"> -->
              <el-table ref="tb1" style="margin-top: 20px;  flex: initial;height: 400px;flex: 0 0 400px;"  max-height="400"  v-if="hisBillList" :data="hisBillList" :loading="isHisLoading" resizable border>
                <!-- 配置列 -->
                <template v-for="(item, index) in hisTableColumns">
                  <!-- 字典 -->
                  <el-table-column
                    v-if="item.selected && item.dicGroup && !item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                    :column-key="item.columnCode"
                    :filter-multiple="true"
                    :filters="item.filters"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row, column }">
                      {{ getDicValue(item.dicGroup, row[column.property]) }}
                    </template>
                  </el-table-column>
                  <!-- 单位 -->
                  <el-table-column
                    v-if="item.selected && item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                  >
                    <template slot-scope="{ row, column }">
                      <span>{{ row[column.property] }}</span>
                      <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.showUnit) }}</span>
                    </template>
                  </el-table-column>
                  <!--
                        datetime 5 时间控件
                    -->
                  <el-table-column
                    v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                  >
                    <template slot-scope="{ row, column }">
                      {{ formatDateTime(row[column.property]) }}
                    </template>
                  </el-table-column>

                  <!-- 非字典  时间控件 -->
                  <el-table-column
                    v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.showUnit"
                    :key="index"
                    :index="index"
                    :prop="item.columnCode"
                    :label="item.columnName"
                    :width="item.width"
                    :formatter="item.isFormat ? formatColumn : null"
                    :sortable="item.isSort ? 'custom' : null"
                    :fixed="item.isLock ? 'right' : null"
                    :column-key="item.columnCode"
                    :filter-multiple="true"
                    :filters="item.filters"
                    show-overflow-tooltip
                  ></el-table-column>
                </template>
                <!-- 占位列 -->
                <el-table-column v-if="!hisTableColumns.length"></el-table-column>
              </el-table>
              <!-- </div> -->
            </template>
            <!-- 固件升级才有固件信息 其余都是输入指令参数 -->
            <firmwareTask-detail-firmwareTable
              v-if="info.serviceType === '3' && info.firmwareInfo && JSON.stringify(info.firmwareInfo) !== '{}'"
              :data="info.firmwareInfo"
            ></firmwareTask-detail-firmwareTable>
            <div class="table-box-list" :class="{ 'table-box-list-bill': `${commandMode}` === '5','table-box-list-firmware': info.serviceType === '3'}">
              <!-- <div class="table-box-list-flex"> -->
                <!--
                  v-if="JSON.stringify(info.commandTaskDetailList) !== '{}'"
                  :data="info.commandTaskDetailList"
                -->
                <!-- 设备信息 -->
                <firmwareTask-detail-deviceTable
                  :serviceType="info.serviceType"
                  :taskId="taskId"
                  @success="getTaskStateInfo"
                ></firmwareTask-detail-deviceTable>
              <!-- </div> -->

            </div>

          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import firmwareTaskDetailFirmwareTable from './firmwareTask_detail_firmwareTable';
import firmwareTaskDetailDeviceTable from './firmwareTask_detail_deviceTable';

export default {
  mixins: [dialogMixins],
  components: {
    firmwareTaskDetailFirmwareTable,
    firmwareTaskDetailDeviceTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // taskId: [Number, String]
  },

  data() {
    return {
      visible: false,
      taskId: '',
      info: {
        firmwareInfo: {
          // firmwareType: ''
        },
      },
      paramList: [],
      paramDataList: [],
      paramTableColumn: [],

      tslContent: [],
      contentList: [],
      isconfigBill: false,
      // 字典name值
      iot_cmd_task_service_type: {},
      progressFlagTimeOut: null,
      // 账单期数
      recoverHisTable: [],
      tableSingleList: [],
      tableSingleColumn: [],
      hisBillList: [],
      hisTableColumns: [],
      commandMode: null,
    };
  },
  mounted() {
    this.initDialog();

    this.getFuncView();
  },
  // destroyed() {
  //   clearTimeout(this.progressFlagTimeOut);
  //   this.progressFlagTimeOut = null;
  // },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // 赋值产品id
      this.taskId = this.model.data.taskId;
      // 查字典
      this.getDictionary('iot_cmd_task_service_type', (data) => {
        this.iot_cmd_task_service_type = this.$transformDicValue(data.iot_cmd_task_service_type);
      });
      this.getTaskStateInfo();
      // 获取账单或指令
      this.getTslCodeList();
    },
    progressFormat: function (percentage) {
      return percentage === '';
    },
    // 获取任务的状态详情
    getTaskStateInfo: function () {
      // 要去掉end
      this.$getJSON(`${apis.commandTaskDevice}/${this.taskId}`).then((res) => {
        this.info = res.data;
        this.info.firmwareInfo = [res.data.resourceBo];
        // 检查升级进度
        // this.cheackUpgrade();
      });
    },
    // 获取正在更新的实时数据
    // getTaskUpgradeList: function () {
    //   this.$getJSON(apis.commandTaskDeviceList, {
    //     taskId: this.taskId,
    //   }).then((res) => {
    //     this.info.commandTaskDetailList = res.data || [];
    //     this.cheackUpgrade();
    //   });
    // },
    // 检查正在升级的进度
    // cheackUpgrade() {
    //   if (JSON.stringify(this.info.commandTaskDetailList) !== '{}') {
    //     // 执行中开关
    //     const progressFlag = this.info.commandTaskDetailList.some(i => i.executeState === 3);
    //     if (progressFlag) {
    //       this.progressFlagTimeOut = setTimeout(() => {
    //         this.getTaskUpgradeList();
    //       }, 3000);
    //     }
    //   }
    // },
    // 获取指令信息 账单
    // 获取所有参数值
    getTslCodeList: function () {
      this.$getJSON(apis.commandTaskTslDataList, {
        taskId: this.taskId,
        // 新
        productCode: this.model.data.productCode,
        tcpVersion: this.model.data.tcpVersion,
        topicCode: this.model.data.topicCode,
      }).then((res) => {
        this.commandMode = res.data[0].commandMode;
        // configBill 是多列
        // list
        this.tslContent = res.data.find(i => i.dataType === 'List');
        this.isconfigBill = res.data.some(i => i.tslCode === 'billContent');
        // 为 list 的
        if (`${this.commandMode}` === '5') {
          this.isHisLoading = false;
          // 没有子级的
          const firstLevelId = res.data.filter(i => `${i.parentId}` === '0');
          // 内容体
          const contentId = res.data.find(i => `${i.parentId}` !== '0').parentId;
          // 过滤内容体
          const tableSingle = firstLevelId.filter(i => i.tslDataId !== contentId);
          const content = firstLevelId.find(i => i.tslDataId === contentId);
          // 一级的单个表格列
          this.tableSingleColumn = tableSingle.map((i) => {
            const item = {};
            item.columnName = i.dataName;
            item.columnCode = i.dataCode;
            item.columnId = i.tslDataId;
            item.widgetType = i.widgetType;
            item.dicGroup = i.dicGroup;
            item.showUnit = i.showUnit;
            item.selected = true;
            return item;
          });
          // 一级的数据  取dataValue值
          const recoverTable = [];
          tableSingle.forEach((i) => {
            const item = {};
            item[i.dataCode] = i.dataValue || '-';
            recoverTable.push(item);
            // return item;
          });
          let recoverTableobj = {};
          recoverTable.forEach((item) => {
            recoverTableobj = { ...recoverTableobj, ...item };
          });
          this.recoverHisTable = [recoverTableobj];
          this.hisBillList = content.dataValue || [];
          // this.hisBillList = [{
          //   billNum: 1,
          //   billEndDate: '2012-10-02',
          //   deferredDuration: '10',
          //   unlockPwd: '321322',
          //   paid: '0'
          // }];

          // 不为0 有下级的都是下面的表格列
          const paramColumn = res.data.filter(i => `${i.parentId}` !== '0');
          this.hisTableColumns = paramColumn.map((i) => {
            const item = {};
            item.columnName = i.dataName;
            item.columnCode = i.dataCode;
            item.columnId = i.tslDataId;
            item.widgetType = i.widgetType;
            item.dicGroup = i.dicGroup;
            item.showUnit = i.showUnit;
            item.selected = true;
            // 账单状态要用字典
            // if (i.dataCode === 'paid') {
            //   this.paidDicGroup = i.dicGroup;
            // }
            return item;
          });
        } else {
          // 非list 普通tsl
          // const editArr = res.data;
          res.data.forEach((i) => {
            // 设置表格列
            let column = {};
            column = i;
            column.columnCode = i.dataCode;
            column.columnName = i.dataName;
            column.widgetType = i.widgetType;
            if (column.columnCode === 'size') {
              column.columnName = `${column.columnName} (${i.showUnit})`;
            }
            this.paramTableColumn.push(column);
          });
          const obj = {};
          res.data.forEach((i) => {
            obj[i.columnCode] = i.dataValue;
          });
          this.contentList.push(obj);

          // this.billContent = res.data;
        }
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },
    saveProtocolConfig: function () {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.frmware-task-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;

  span[role='heading']:focus {
    outline: none;
  }
  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;

    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .el-drawer__body {
    position: relative;
    padding: 0px;

    .info-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .info-content-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        padding: 0px !important;
        .info-box {
          flex: 0 0 300px;
          width: 300px;
          padding: 0 24px 24px;
          // margin-right: 24px;
          background-color: #f8f9fb;
          // height: 100%;
          .title {
            height: 70px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(57, 70, 104, 1);
            line-height: 70px;
          }
          .information {
            .line {
              height: 40px;
              line-height: 40px;
              background: rgba(255, 255, 255, 0);
              border-bottom: 1px solid rgba(238, 242, 247, 1);
              font-size: 12px;
              color: rgba(108, 117, 125, 1);
              span {
                float: right;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }
            }
            .line-break {
              p {
                height: 40px;
                line-height: 40px;
                background: rgba(255, 255, 255, 0);
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }
              span {
                font-size: 12px;
                color: rgba(152, 166, 173, 1);
                line-height: 17px;
                padding-bottom: 11px;
                border-bottom: 1px solid rgba(238, 242, 247, 1);
              }
            }
          }
          .device-num {
            height: 60px;
            font-size: 12px;
            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 60px;
            margin-top: 10px;
            span {
              float: right;
              height: 60px;
              font-size: 12px;
              font-weight: bold;
              color: rgba(73, 80, 87, 1);
              line-height: 60px;
            }
          }
          .device {
            .line {
              height: 36px;
              line-height: 36px;
              display: flex;
              .l {
                width: 60px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .progress {
                flex: 0 0 155px;
                margin: 0 auto;
                height: 6px;
                // line-height: 36px;
                .el-progress {
                  padding: 11px 0;
                  width: 155px;
                }
              }
              .right {
                height: 36px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
                line-height: 36px;
              }
            }
          }
        }
        .table-box {
          padding: 0 24px;
          box-sizing: border-box;
          // margin-bottom: 60px;
          // height: 0;
          flex: 1;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          .table-title {
            height: 60px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 60px;
          }
          .title {
            height: 40px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(57, 70, 104, 1);
            line-height: 40px;
          }
          .table-bd {
            height: 100%;
          }
          .table-box-list{
            height: calc(100vh - 240px);
            // flex: 1;
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;
          }
          .table-box-list-firmware{
            height: calc(100vh - 420px)
          }
          .table-box-list-bill{
            height: calc(100vh - 660px)
          }
        }
      }
    }
  }

  .drawer__footer {
    padding: 16px 24px;
    border-top: 1px solid #e9ebec;
    box-sizing: border-box;
  }
}
</style>
